webpackJsonp([107818501498521],{

/***/ 76:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(68);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navbar = __webpack_require__(19);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _mobileContent = __webpack_require__(23);
	
	var _mobileContent2 = _interopRequireDefault(_mobileContent);
	
	var _formsShared = __webpack_require__(44);
	
	var _shibui = __webpack_require__(15);
	
	var _sharedStyles = __webpack_require__(63);
	
	var _sharedStyles2 = _interopRequireDefault(_sharedStyles);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _icons = __webpack_require__(73);
	
	__webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var S = _extends({
	  blogHeaderWrap: _extends({}, _sharedStyles2.default.flexCenter, {
	    width: '100%',
	    textAlign: 'center',
	    marginTop: _shibui.spacing.lg
	  }),
	  blogWrap: {
	    marginTop: 0,
	    width: '100%',
	    color: _shibui.colors.seattle50.color,
	    minHeight: 200,
	    display: 'inline-block',
	    padding: '60px 10px 100px'
	  },
	  blogContentWrap: {
	    margin: '0 auto',
	    backgroundColor: 'rgb(252,252,252)',
	    borderRadius: 12,
	    width: '98%',
	    maxWidth: 980,
	    minWidth: 300,
	    padding: '20px 46px 20px',
	    minHeight: 'calc(100vh - 260px)',
	    boxShadow: _shibui.shadows.modal.boxShadow
	  },
	  keepReadingWrap: {
	    margin: '0 auto',
	    width: '98%',
	    maxWidth: 980,
	    minWidth: 300
	  },
	  link: {
	    textDecoration: 'none'
	  },
	  authorWrap: {
	    textAlign: 'center',
	    display: 'block',
	    textDecoration: 'none',
	    marginTop: -40,
	    fontSize: 16
	  },
	  authorHeadshot: {
	    backgroundColor: _shibui.colors.ivory.color,
	    backgroundPosition: '50% 50%',
	    backgroundRepeat: 'no-repeat',
	    borderRadius: 40,
	    height: 60,
	    left: 'calc(50% - 30px)',
	    top: -50,
	    position: 'relative',
	    width: 60,
	    margin: '0 auto'
	  },
	  authorName: {
	    fontWeight: 'bold',
	    marginTop: 7,
	    marginBottom: 0,
	    color: _shibui.colors.graphite.color,
	    fontSize: 16
	  },
	  authorBlurb: {
	    marginTop: -2,
	    marginBottom: 0,
	    color: _shibui.colors.graphite.color,
	    fontSize: 16
	  },
	  twitterContainer: {
	    position: 'relative'
	  },
	  twitterLogo: {
	    cursor: 'pointer',
	    top: -1,
	    position: 'absolute'
	  },
	  blogPost: {
	    fontSize: '1.2rem',
	    color: _shibui.colors.midnight.color
	  },
	  keepReadingContent: {
	    padding: 12
	  },
	  keepReadingTitle: {
	    textTransform: 'uppercase',
	    fontSize: 22,
	    marginTop: 5,
	    marginBottom: 5
	  },
	  keepReadingSubtitle: {
	    color: _shibui.colors.midnight.color,
	    marginTop: 80
	  },
	  keepReadingAuthorWrap: {
	    display: 'block',
	    textDecoration: 'none',
	    position: 'relative',
	    minHeight: 50
	  },
	  keepReadingAuthorHeadshot: {
	    backgroundColor: _shibui.colors.ivory.color,
	    backgroundPosition: '50% 50%',
	    backgroundRepeat: 'no-repeat',
	    borderRadius: 20,
	    position: 'absolute',
	    height: 40,
	    left: 0,
	    bottom: 0,
	    width: 40
	  },
	  keepReadingAuthorName: {
	    position: 'absolute',
	    bottom: 8,
	    left: 50,
	    marginBottom: 0,
	    color: _shibui.colors.midnight.color,
	    fontSize: 16
	  },
	  keepReading: {
	    backgroundColor: _shibui.colors.ivory.color,
	    paddingBottom: _shibui.spacing.md,
	    height: 'auto'
	  },
	  tag: {
	    fontSize: 14,
	    background: _shibui.colors.amethyst50.color,
	    color: _shibui.colors.ivory.color,
	    borderRadius: 4,
	    padding: 5,
	    marginTop: 15,
	    display: 'inline-block'
	  }
	}, _formsShared.FORM_STYLES);
	
	var Template = function (_Component) {
	  _inherits(Template, _Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    setTimeout(function () {
	      window.scrollTo(0, 0);
	    });
	  };
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        pathContext = _props.pathContext;
	    var post = data.markdownRemark; // data.markdownRemark holds our post data
	
	    var next = pathContext.next,
	        prev = pathContext.prev;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Haiku Blog - ' + post.frontmatter.title
	        ),
	        post.excerpt && _react2.default.createElement('meta', { name: 'description', content: post.excerpt }),
	        post.frontmatter.canonicalUrl && _react2.default.createElement('link', { rel: 'canonical', href: post.frontmatter.canonicalUrl }),
	        post.frontmatter.title && _react2.default.createElement('meta', { property: 'og:title', content: post.frontmatter.title }),
	        post.excerpt && _react2.default.createElement('meta', { property: 'og:description', content: post.excerpt }),
	        post.frontmatter.coverImage.publicURL && _react2.default.createElement('meta', { property: 'og:image', content: '' + ("https://www.haikuanimator.com") + post.frontmatter.coverImage }),
	        post.frontmatter.path && _react2.default.createElement('meta', { property: 'og:url', content: '' + ("https://www.haikuanimator.com") + post.frontmatter.path })
	      ),
	      _react2.default.createElement(_navbar2.default, { location: 'blog' }),
	      _react2.default.createElement(
	        'div',
	        { style: {
	            margin: '0 auto',
	            width: '100%'
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: S.blogHeaderWrap },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/blog/' },
	            _react2.default.createElement(
	              'h1',
	              { style: _extends({}, _shibui.typography.heading1, _sharedStyles2.default.centerer, { margin: _shibui.spacing.sm + 'px 0 0', color: _shibui.colors.midnight.color }) },
	              'Haiku Blog'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: _sharedStyles2.default.subtitle },
	              'Articles, videos and resources by the Haiku team.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: S.blogWrap },
	          _react2.default.createElement(
	            'div',
	            { style: S.blogContentWrap },
	            _react2.default.createElement(
	              'div',
	              { className: 'blog-post-container' },
	              _react2.default.createElement('img', { src: post.frontmatter.authorHeadshot, style: S.authorHeadshot, alt: post.frontmatter.authorName }),
	              _react2.default.createElement(
	                'div',
	                { style: S.authorWrap },
	                _react2.default.createElement(
	                  'div',
	                  { style: S.authorName },
	                  post.frontmatter.authorName,
	                  post.frontmatter.twitterLink && _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: post.frontmatter.twitterLink, style: S.twitterContainer },
	                    _react2.default.createElement(
	                      'span',
	                      { style: S.twitterLogo },
	                      _react2.default.createElement(_icons.TwitterSVG, { color: 'rgb(72,160,236)' })
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: S.authorBlurb },
	                  post.frontmatter.authorBlurb
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'blog-post', style: S.blogPost },
	                _react2.default.createElement(
	                  'div',
	                  { style: { textAlign: 'center', marginTop: 0 } },
	                  _react2.default.createElement(
	                    'h2',
	                    { style: _extends({}, _shibui.typography.heading2, { textAlign: 'center' }) },
	                    post.frontmatter.title
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { style: _extends({}, S.authorBlurb, { marginTop: _shibui.spacing.md }) },
	                    post.frontmatter.date,
	                    post.frontmatter.readLength && _react2.default.createElement(
	                      'span',
	                      null,
	                      ' - ',
	                      post.frontmatter.readLength,
	                      ' min read'
	                    )
	                  ),
	                  post.frontmatter.tags && post.frontmatter.tags.map(function (tag, index) {
	                    return _react2.default.createElement(
	                      'span',
	                      { key: 'tag' + index, style: S.tag },
	                      tag
	                    );
	                  })
	                ),
	                _react2.default.createElement('div', {
	                  className: 'blog-post-content',
	                  dangerouslySetInnerHTML: { __html: post.html }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: S.keepReadingWrap },
	            _react2.default.createElement(
	              'div',
	              { className: 'keep-reading' },
	              next && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h5',
	                  { style: S.keepReadingSubtitle },
	                  'Previous Post'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'link next', to: next.path },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'keep-reading-block', style: S.keepReading },
	                    _react2.default.createElement('img', { className: 'blogFeatureImage', src: next.coverImage.publicURL, alt: next.title }),
	                    _react2.default.createElement(
	                      'div',
	                      { style: S.keepReadingContent },
	                      _react2.default.createElement(
	                        'p',
	                        { style: _sharedStyles2.default.heading5 },
	                        next.title
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { style: S.keepReadingAuthorWrap },
	                        _react2.default.createElement('img', { src: next.authorHeadshot, style: S.keepReadingAuthorHeadshot, alt: next.authorName }),
	                        _react2.default.createElement(
	                          'p',
	                          { style: S.keepReadingAuthorName },
	                          next.authorName
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              prev && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'h5',
	                  { style: S.keepReadingSubtitle },
	                  'Next Post'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'link prev', to: prev.path },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'keep-reading-block', style: S.keepReading },
	                    _react2.default.createElement('img', { className: 'blogFeatureImage', src: prev.coverImage.publicURL, alt: prev.title }),
	                    _react2.default.createElement(
	                      'div',
	                      { style: S.keepReadingContent },
	                      _react2.default.createElement(
	                        'p',
	                        { style: _sharedStyles2.default.heading5 },
	                        prev.title
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { style: S.keepReadingAuthorWrap },
	                        _react2.default.createElement('img', { src: prev.authorHeadshot, style: S.keepReadingAuthorHeadshot, alt: prev.authorName }),
	                        _react2.default.createElement(
	                          'p',
	                          { style: S.keepReadingAuthorName },
	                          prev.authorName
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_mobileContent2.default, null)
	    );
	  };
	
	  return Template;
	}(_react.Component);
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-b912f512ec6e8a177bcb.js